/**
 * Đăng ký service worker của TT Vessels (docs/13-tasks/01-ui-chrome.md#17 §3).
 *
 * Bản thân `public/sw.js` không cache gì — nó tồn tại vì Chrome chỉ mời "Cài ứng dụng" khi trang
 * có manifest VÀ một service worker có xử lý `fetch`.
 *
 * ⚠️ Chỉ đăng ký ở bản dựng thật. Ở `npm run dev` mà cắm service worker vào thì lần sau mở
 * localhost của một dự án KHÁC trên cùng cổng sẽ dính bản đã đăng ký của dự án này.
 * ⚠️ `register` hỏng ở ngữ cảnh không an toàn (http không phải localhost) — nuốt lỗi, vì cài
 * được hay không là chuyện phụ, trang vẫn phải chạy.
 */
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* Không cài được thì thôi: trang vẫn chạy đầy đủ trong tab thường. */
    });
  });
}
